import { render, staticRenderFns } from "./StudentProfileEdit.vue?vue&type=template&id=0cecf548&scoped=true&"
import script from "./StudentProfileEdit.vue?vue&type=script&lang=js&"
export * from "./StudentProfileEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileEdit.vue?vue&type=style&index=0&id=0cecf548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cecf548",
  null
  
)

export default component.exports